module.exports = __webpack_public_path__ + "img/jiaofu.46a5d39b.jpg";